<div class="container-fluid py-4">
  <div class="py-4 heading-container">
    <div class="d-inline-block align-middle me-2">
      <svg-icon src="assets/icons/icon-search.svg" class="icon-search"></svg-icon>
    </div>
    <!-- Use this content to place the search header -->
    <ng-content select="[search-header]"></ng-content>
  </div>
  <div *ngIf="searchOptions.length">
    <app-search-fields [searchOptions]="searchOptions" (search)="onSearch($event)"></app-search-fields>
    <!-- Use this content to place the search results -->
    <ng-content select="[search-results]"></ng-content>
  </div>
</div>
